<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        صورتجلسات من
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label>شماره صورتجلسه :</label>
                  <b-form-input
                      v-model="search.id"
                      placeholder="شماره صورتجلسه را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>عنوان صورتجلسه:</label>
                  <b-form-input
                      v-model="search.title"
                      placeholder="عنوان را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>متن شامل:</label>
                  <b-form-input
                      v-model="search.description"
                      placeholder="بخشی از متن را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="role">
                    اعضا
                  </label>
                  <v-select
                      v-model="search.members"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="member => member.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>

              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="role">
                    مجریان مصوبه
                  </label>
                  <v-select
                      v-model="search.approvalUsers"
                      multiple
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="user => user.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group
                    label="جلسات از تاریخ"
                    label-for="meetingFrom"
                >
                  <date-picker
                      v-model="search.meetingFrom"
                      type="datetime"
                      display-format="jDD jMMMM jYYYY HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      :max="search.meetingTo"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="جلسات تا تاریخ"
                    label-for="meetingTo"
                >
                  <date-picker
                      v-model="search.meetingTo"
                      type="datetime"
                      display-format="jDD jMMMM jYYYY HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      :min="search.meetingFrom"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="سررسید از تاریخ"
                    label-for="dueDateFrom"
                >
                  <date-picker
                      v-model="search.dueDateFrom"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      :max="search.dueDateTo"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="سررسید تا تاریخ"
                    label-for="dueDateTo"
                >
                  <date-picker
                      v-model="search.dueDateTo"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      :min="search.dueDateFrom"
                      clearable
                  />

                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      نوع مصوبه:
                    </label>
                    <b-form-radio
                        v-model="search.type"
                        name="agenda-type"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.type"
                        name="agenda-type"
                        value="publish"
                    >
                      نهایی شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.type"
                        name="agenda-type"
                        value="draft"
                    >
                      پیش نویس
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.type"
                        name="agenda-type"
                        value="canceled"
                    >
                      لغو شده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      وضعیت نهایی مصوبات:
                    </label>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value="done"
                    >
                      تکمیل شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value="todo"
                    >
                      تکمیل نشده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">

          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >
            <template #cell(priority)="data">
              <b-badge
                  :variant="data.value.label"
                  class="mr-1"
              >
                {{ data.value.title }}
              </b-badge>
            </template>
            <template #cell(title)="data">
              {{ data.value }}
              <feather-icon
                  v-show="data.item.attachmentCount"
                  :id="`invoice-row-${data.item.id}`"
                  icon="PaperclipIcon"
              />
            </template>
            <template #cell(progress)="data">
              <b-progress
                  max="100"
              >
                <b-progress-bar
                    :value="data.value"
                    :label="`${(data.value).toFixed(0)}%`"
                    :variant="`${data.value == 100 ? 'success' : 'primary'}`"
                    striped
                />
              </b-progress>
            </template>
            <template #cell(type)="data">
              <b-badge :variant="data.value.label">
                {{ data.value.title }}
              </b-badge>
            </template>
            <template #cell(action)="data">
              <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  :to="{name: 'Agendas_Detail', params:{id: data.item.id}}"
              >
                <feather-icon
                    icon="FileTextIcon"
                    class="mr-50"
                />
                <span class="align-middle">مشاهده</span>
              </b-button>

            </template>

          </b-table>
          <b-pagination
              v-model="currentPage"
              class="mt-2"
              :total-rows="totalRows"
              :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination,
  BBadge, BButton,
  VBTooltip, BCollapse, BFormInput, BFormRadio, BRow, BCol, BFormGroup, VBToggle,
  BProgress,
  BProgressBar,BForm
} from 'bootstrap-vue'

import ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import { doubleRaf, queryString } from '@/libs/utils'
import { debounce } from '@/libs/debounce'

export default {
  name: 'SaleGroupList',
  components: {
    BFormGroup,
    BCol,
    BRow,
    BFormRadio,
    BFormInput,
    VSelect,
    BCollapse,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BBadge,
    BProgress,
    BProgressBar,
    BForm
  },
  directives: {
    'b-tooltip': VBTooltip,
    ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شماره',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'creator.name',
          label: 'سازنده',
        },
        {
          key: 'progress',
          label: 'میزان پیشرفت',
        },
        {
          key: 'type',
          label: 'وضعیت',
        },
        {
          key: 'meetingDate',
          label: 'تاریخ جلسه',
        },
        {
          key: 'updatedAt',
          label: 'آخرین بروزرسانی',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      search: {},
      receiversList: [],
      getReceivers: false,
      onExportProgress: false,
      prioritiesList: [],
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}agendas/inbox?export-excel=1&${query}`
    },
  },
  methods: {
    async getAgendaList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true
      this.$http.get('agendas/inbox', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
          .then(({ data }) => {
            if (data.status) {
              this.items = data.agendas
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
            } else {
              this.$bvToast.toast(data.message ?? 'لیست صورتجلسه ها دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    deleteTicket(id) {
      this.$swal({
        title: 'حذف صورتجلسه ',
        text: 'آیا از حذف صورتجلسه مطمئن هستید؟',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'لغو حذف',
        confirmButtonText: 'حذف صورتجلسه',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-success',
        },
      })
          .then(async result => {
            if (result.value) {
              this.$swal({
                title: 'در حال انجام',
                text: 'لطفا تا دریافت نتیجه منتظر بمانید',
                icon: 'info',
                confirmButtonText: 'متوجه شدم',
              })
              await this.$http.delete(`agendas/delete/${id}`)
                  .then(({ data }) => {
                    if (data.status) {
                      this.$swal({
                        title: 'حذف شد',
                        text: 'حذف صورتجلسه  با موفقیت انجام شد',
                        icon: 'success',
                        confirmButtonText: 'متوجه شدم',
                        timer: 2000,
                      })
                      this.items = []
                      this.getAgendaList()
                    } else {
                      this.$bvToast.toast(data.message ?? 'حذف صورتجلسه  با خطا مواجه شد', {
                        title: 'خطای دریافت اطلاعات',
                        toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                        variant: 'danger',
                      })
                    }
                  })
                  .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                      variant: 'danger',
                    })
                  })
            }
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getAgendaList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getAgendaList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$router.push({
          name: 'Agendas_Inbox',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getAgendaList()
      }
    },
  },
  mounted() {
    this.getAgendaList()
    this.setSearchData()
  },
}
</script>

<style>

</style>
